import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../authorization/authService";

export const feedbackApi = createApi({
  reducerPath: "feedbackApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Feedback"],
  endpoints: (builder) => ({
    createFeedback: builder.mutation({
      query: (feedbackData) => ({
        url: "/feedback",
        method: "POST",
        body: feedbackData,
      }),
      invalidatesTags: ["Feedback"],
    }),
    submitUnregisteredUserFeedback: builder.mutation({
      query: (formData) => ({
        url: "/feedback/submit-unregistered-user",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Feedback"],
    }),
    updateFeedbackResolvedStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/feedback/${id}/resolve`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: ["Feedback"],
    }),
    getFeedbackList: builder.query({
      query: (params) => ({
        url: "/feedback/list",
        method: "GET",
        params,
      }),
      providesTags: ["Feedback"],
    }),
    getFeedbackDetail: builder.query({
      query: (id) => ({
        url: `/feedback/${id}`,
        method: "GET",
      }),
      providesTags: ["Feedback"],
    }),
  }),
});

export const {
  useCreateFeedbackMutation,
  useSubmitUnregisteredUserFeedbackMutation,
  useUpdateFeedbackResolvedStatusMutation,
  useGetFeedbackListQuery,
  useGetFeedbackDetailQuery,
} = feedbackApi;
